// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.ui-form.ui-tooltip .ui-input-root > label.ui-input-label:not(:empty) {
    /* min-width: 30px; /* Breaks right margin /**/
}

.ui-form.ui-tooltip .ui-input-root > div.ui-input-text:not(:empty) {
    margin-top: 6px;
}`, "",{"version":3,"sources":["webpack://./css/cell-renderer.css"],"names":[],"mappings":";AACA;IACI,8CAA8C;AAClD;;AAEA;IACI,eAAe;AACnB","sourcesContent":["\n.ui-form.ui-tooltip .ui-input-root > label.ui-input-label:not(:empty) {\n    /* min-width: 30px; /* Breaks right margin /**/\n}\n\n.ui-form.ui-tooltip .ui-input-root > div.ui-input-text:not(:empty) {\n    margin-top: 6px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
